import { toggleScrollLock } from 'common/utils';
import Cookie from 'js-cookie';
import Api from 'api/ApiClient';

const ageGate = document.getElementById('age-gate');
const ageGateConfirmation = document.getElementById('age-gate-confirmation');
const ageGateStatesDropdown = document.getElementById('age-gate-states');
const ageGateBlockedStateWarning = document.getElementById(
  'age-gate-blocked-state-warning'
);
const oneMonth = 30 * 24 * 60 * 60; // one month in seconds

const scrollLockSelector = '#age-gate .Modal__content';

ageGate && toggleScrollLock(scrollLockSelector, true);

ageGateConfirmation &&
  ageGateConfirmation.addEventListener('click', () => {
    toggleScrollLock(scrollLockSelector, false);
    Cookie.set('hasVerifiedAgeGate', true, { expires: oneMonth });
    if (window.location.pathname.includes('locator')) {
      // TODO: Remove once full site launches. This prevents a user to be prompted twice with the age gate if they land on /locator
      Cookie.set('store', 'juul_us_en', { expires: oneMonth });
    }

    if (ageGateStatesDropdown) {
      ageGateConfirmation.setAttribute('disabled', true);
      const stateSelection =
        ageGateStatesDropdown[ageGateStatesDropdown.selectedIndex].value;

      Api.sessionStateAbbr(stateSelection)
        .then(response => {
          // If the user has selected a state with its own pricing scheme we
          // must reload the page in order to get updated prices
          if (response.state_has_pricing) {
            window.location.search += `&ag=${response.state_abbr}`;
          } else {
            ageGate.remove();
          }
        })
        .catch(error => {
          bugsnagClient && bugsnagClient.notify(error);
        });
    } else {
      ageGate.remove();
    }
  });

if (ageGateStatesDropdown) {
  let ageGateBlockedStates = ageGateStatesDropdown.dataset.blockedStates;
  ageGateBlockedStates = ageGateBlockedStates
    ? JSON.parse(ageGateBlockedStates)
    : [];
  if (ageGateBlockedStates.length > 0) {
    ageGateConfirmation.setAttribute('disabled', true);
  }

  ageGateStatesDropdown.addEventListener('change', () => {
    if (ageGateStatesDropdown.selectedIndex && ageGateBlockedStateWarning) {
      const selectedState =
        ageGateStatesDropdown[ageGateStatesDropdown.selectedIndex].value;
      if (ageGateBlockedStates.includes(selectedState)) {
        ageGateBlockedStateWarning.classList.remove('hide');
        ageGateConfirmation.setAttribute('disabled', true);
      } else {
        ageGateBlockedStateWarning.classList.add('hide');
        ageGateConfirmation.removeAttribute('disabled');
      }
    }
  });

  // Preselect the user's state if we have a geo location for them and its
  // available in the list that they are viewing
  if (gon.geo_location && gon.geo_location.state_abbr) {
    const state_abbr = gon.geo_location.state_abbr;
    const availableStates = Array.from(ageGateStatesDropdown.options).map(
      option => option.value
    );
    if (availableStates.includes(state_abbr)) {
      ageGateStatesDropdown.value = state_abbr;
      ageGateStatesDropdown.dispatchEvent(new CustomEvent('change'));
    }
  }
}
